// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerBranchPhoneNumberStyles } from "@conklin/App/Widgets/Header/HeaderBranchPhoneNumber";
import IconHeaderPhone from "@conklin/XDL/Icons/IconHeaderPhone";
import { color, createLinkIconStyles } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

headerBranchPhoneNumberStyles.phoneLink = {
    ...createLinkIconStyles(IconHeaderPhone, "small", "left", false, {
        css: css`
            &&& ${IconWrapper}, &&& svg {
                width: 9px;
                color: ${color("primary.main")};
            }
        `,
    }),
}